export const environment = {
  production: false,
  mode: 'sit',
  facebookAppID: '878990966065939',
  meadEndpoint: 'https://mead-sit.goskyai.com',
  platformEndpoint: 'https://platform-sit.goskyai.com/api/v1',
  googleStorageEndpoint: 'https://storage.googleapis.com/malasun-sit',
  tapPayAppID: 153261,
  googleClientID:
    '295607523408-9tstoj9outm34edkkq6lhunaiuoep570.apps.googleusercontent.com',
  gtmCode: 'GTM-PVSB5ML5',
  threadsAppID: '523375417411127',
  igAppID: '1119353102743966',
  // OpenAI Ads pixel 只在 PROD 啟用，見 environment.prod.ts
  openaiAdsPixelId: '',
};
